import { render, staticRenderFns } from "./arrived-table.vue?vue&type=template&id=96bba618"
import script from "./arrived-table.vue?vue&type=script&lang=js"
export * from "./arrived-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports